// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__aDjz_","arrows":"style_arrows___4IT8"};